export const ORDER_STATUS_LABELS = {
  pending_payment: 'Awaiting payment',
  received: 'Order received',
  preparing: 'Being prepared',
  ready: 'Ready',
  out_for_delivery: 'Out for delivery',
  delivered: 'Delivered',
  completed: 'Completed',
  cancelled: 'Cancelled',
};

/**
 * Contextual status label that combines status + order type so kitchen / staff
 * instantly know WHAT to do next with this ticket.
 *
 * Example: ready + pickup → "READY FOR PICKUP"
 *          ready + dine_in → "READY TO SERVE · Table 5"
 *          ready + delivery → "READY FOR DISPATCH"
 *          out_for_delivery → "EN ROUTE TO CUSTOMER"
 */
export function getContextualStatusLabel(status, orderType, tableNumber) {
  if (status === 'pending_payment') return 'AWAITING PAYMENT';
  if (status === 'received') {
    if (orderType === 'pickup') return 'NEW · PICKUP ORDER';
    if (orderType === 'dine_in') return `NEW · DINE-IN${tableNumber ? ` · Table ${tableNumber}` : ''}`;
    if (orderType === 'delivery') return 'NEW · DELIVERY ORDER';
  }
  if (status === 'preparing') {
    if (orderType === 'pickup') return 'COOKING FOR PICKUP';
    if (orderType === 'dine_in') return `COOKING FOR DINE-IN${tableNumber ? ` · Table ${tableNumber}` : ''}`;
    if (orderType === 'delivery') return 'COOKING FOR DELIVERY';
  }
  if (status === 'ready') {
    if (orderType === 'pickup') return 'READY FOR PICKUP';
    if (orderType === 'dine_in') return `READY TO SERVE${tableNumber ? ` · Table ${tableNumber}` : ''}`;
    if (orderType === 'delivery') return 'READY FOR DISPATCH';
  }
  if (status === 'out_for_delivery') return 'EN ROUTE TO CUSTOMER';
  if (status === 'delivered') return 'DELIVERED';
  if (status === 'completed') {
    if (orderType === 'pickup') return 'PICKED UP';
    if (orderType === 'dine_in') return 'CLOSED · DINE-IN';
    return 'COMPLETED';
  }
  if (status === 'cancelled') return 'CANCELLED';
  return ORDER_STATUS_LABELS[status] || status;
}

/**
 * Friendly next-action button text for staff to advance an order.
 */
export function getNextActionLabel(status, orderType) {
  if (status === 'received') return 'Start cooking';
  if (status === 'preparing') {
    if (orderType === 'pickup') return 'Mark ready for pickup';
    if (orderType === 'dine_in') return 'Mark ready to serve';
    if (orderType === 'delivery') return 'Mark ready for dispatch';
    return 'Mark ready';
  }
  if (status === 'ready') {
    if (orderType === 'pickup') return 'Hand to customer';
    if (orderType === 'dine_in') return 'Mark served';
    if (orderType === 'delivery') return 'Dispatch to driver';
    return 'Complete';
  }
  if (status === 'out_for_delivery') return 'Delivered';
  return '';
}

export const ORDER_STATUS_COLORS = {
  pending_payment: 'bg-amber-100 text-amber-900 border-amber-200',
  received: 'bg-blue-100 text-blue-900 border-blue-200',
  preparing: 'bg-orange-100 text-orange-900 border-orange-200',
  ready: 'bg-emerald-100 text-emerald-900 border-emerald-200',
  out_for_delivery: 'bg-violet-100 text-violet-900 border-violet-200',
  delivered: 'bg-emerald-100 text-emerald-900 border-emerald-200',
  completed: 'bg-slate-100 text-slate-900 border-slate-200',
  cancelled: 'bg-rose-100 text-rose-900 border-rose-200',
};

export const ORDER_FLOW = [
  'received',
  'preparing',
  'ready',
  'out_for_delivery',
  'delivered',
];
